import { MixpanelIdentify } from 'components/Analytics/MixpanelIdentify';
import { PageViewTracker } from 'components/Analytics/PageViewTracker';
import Wootric from 'components/Wootric';
import { LanguageProvider as NewLanguageProvider } from 'contexts/LanguageContext';
import { Bitrix24IntlProvider } from 'providers/Bitrix24IntlProvider';
import ActiveProvider from 'providers/legacy/ActiveProvider';
import Bitrix24Provider from 'providers/legacy/Bitrix24Provider';
import LanguageProvider from 'providers/legacy/LanguageProvider';
import NumberProvider from 'providers/legacy/NumberProvider';
import SystemProvider from 'providers/legacy/SystemProvider';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppRoutes } from 'routes/AppRoutes';
import { PrivacyPage } from 'views/PrivacyPage';
import { TermsPage } from 'views/TermsPage';
import { createTheme, MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/tiptap/styles.css';

export function App() {
	const theme = createTheme({});

	return (
		<MantineProvider theme={theme} forceColorScheme="light">
			<BrowserRouter>
				<Routes>
					<Route path={`${process.env.PUBLIC_URL}/legal/terms`} element={<TermsPage />} />
					<Route path={`${process.env.PUBLIC_URL}/legal/privacy`} element={<PrivacyPage />} />
					<Route
						path="*"
						element={
							<Bitrix24Provider>
								<ActiveProvider>
									<LanguageProvider>
										<SystemProvider>
											<NumberProvider>
												<NewLanguageProvider>
													<Bitrix24IntlProvider>
														<Wootric />
														<MixpanelIdentify />
														<PageViewTracker />
														<AppRoutes />
													</Bitrix24IntlProvider>
												</NewLanguageProvider>
											</NumberProvider>
										</SystemProvider>
									</LanguageProvider>
								</ActiveProvider>
							</Bitrix24Provider>
						}
					/>
				</Routes>
			</BrowserRouter>
		</MantineProvider>
	);
}
